import { useQuery } from '@tanstack/react-query';
import { supabase } from '../lib/supabase';

export function useCustomersAndLocations() {
  return useQuery({
    queryKey: ['estimator-customers-locations'],
    queryFn: async () => {
      const [customersRes, locationsRes] = await Promise.all([
        supabase
          .from('customers')
          .select('id, name, account_number')
          .is('deleted_at', null)
          .order('name'),
        supabase
          .from('locations')
          .select('id, customer_id, name, type, contact_name, contact_email, contact_phone, address')
          .is('deleted_at', null)
          .order('name'),
      ]);
      if (customersRes.error) throw customersRes.error;
      if (locationsRes.error) throw locationsRes.error;
      return {
        customers: customersRes.data ?? [],
        locations: locationsRes.data ?? [],
      };
    },
    staleTime: 2 * 60 * 1000,
  });
}
